'use strict';

/*global Container */
/*global Translator */
/*global Configurations*/
/*global K2Modal */
/*global K2Confirm */
/*global ConfirmService */

var services = new Container();
$(document).ready(function () {
  services.set('translator', new Translator('k2_translations'));
  services.set('configurations', new Configurations('k2_configurations'));
  services.set('modal', new K2Modal('k2-modal'));
  services.set('confirm', new K2Confirm('k2-confirm'));
  services.set('modal-lookup', new K2Modal('k2-modal-lookup'));
  services.set('confirm-service', new ConfirmService());
});
